<template>
  <div :class="['mobile-verification-code', m > 0 ? '' : 'get']" @click="getSmsCode">
    {{ m > 0 ? m + "s后重新发送" : "获取动态码" }}
  </div>
</template>

<script>
import { isPhone } from "../../lib/verification/index"
export default {
  name: "MobileVerificationCode",
  props: {
    source: {
      type: String,
      default: 'reg'
    },
    type: {
      type: Number,
      default: null
    },
    obj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ST: null,
      m: 0
    }
  },
  beforeDestroy() {
    clearInterval(this.ST)
  },
  methods: {
    getSmsCode() {
      if (this.m > 0) return
      const { mobile, imgCode } = this.obj
      if ((this.source === "login" && !mobile) || (this.source === "reg" && !mobile) || (this.source === "newMobile" && !mobile)) {
        this.$Message.error("手机号不能为空")
        return
      }
      if ((this.source === "login" && !imgCode) || (this.source === "reg" && !imgCode) || (this.source === "oldMobile" && !imgCode) || (this.source === "newMobile" && !imgCode)) {
        this.$Message.error("图形验证码不能为空")
        return
      }
      if (mobile && isPhone(mobile) ) {
        this.$Message.error("请输入正确的手机号")
        return
      }
      if (imgCode && imgCode.length !== 5) {
        this.$Message.error("请输入正确的图形验证码")
        return
      }
      this.m = 60
      this.ST = setInterval(() => {
        if (this.m > 0)  {
          this.m--
        } else {
          clearInterval(this.ST)
        }
      }, 1000)
      this.$store.dispatch("globe/getSmsCode", { mobile, imgCode, type: this.type, source: this.source }).then(({ msg }) => {
        this.$Message.success(msg)
      }).catch(({ msg })  => {
        this.m = 0
        clearInterval(this.ST)
        this.$Message.error(msg)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-verification-code{
  width: 120px;
  height: 50px;
  line-height: 50px;
  background: #F6F7F9;
  margin-left: 20px;
  color: #AAB1C0;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.get{
  border: 1px solid #FFBF81;
  background: white;
  color: #EF8925;
  font-size: 16px;
  line-height: 48px;
}
</style>